import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { DefaultState } from '../../types'
import LoginPageBody from './LoginPageBody'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import './Login.css'
import { ICSModal } from '../../components'
import AcceptableUsagePolicy from './AcceptableUsagePolicy'

const LoginPage = () => {
  const { aupPolicy } = useSelector((state: DefaultState) => state.strategies)
  const [aUP, setAUP] = useState<boolean>()
  
  const acceptPolicy = () => {
    console.log(
      `User has accepted the Acceptable Usage Policy`
    )
    setAUP(false)
  }

  const declinePolicy = () => {
    console.log(
      `User has declined the Acceptable Usage Policy`
    )
    window.alert('To proceed, please read and agree to the policy.')
    setAUP(true)
  }

  useEffect(() => {
    if (aupPolicy.length > 0 && (aUP == false || aUP == undefined)) {
      setAUP(true);
    }
  }, [aupPolicy]);

  if (aUP) {
      return (
        <AcceptableUsagePolicy policy={aupPolicy} accept={acceptPolicy} decline={declinePolicy}/>
      )
  } else {
    return (
      <div
        id="login-background"
        className="fade show"
        role="dialog"
        tabIndex={-1}
      >
        <ICSModal
          id="login_container"
          modalId="login_modal"
          visible={true}
          onHiding={() => {
            return
          }}
          defaultWidth={325}
          closeOnOutsideClick={false}
          position={{
            of: "window",
            at: "top center",
            collision: "fit",
            boundaryOffset: "0 100"
          }}
        >
          <ModalHeader
            className={'ics-modal-header'}
            id="login_img"
          ></ModalHeader>
          <ModalBody className="ics-modal-body form-control" id="login_body">
            <LoginPageBody />
          </ModalBody>
        </ICSModal>
      </div>
    )
  }
}

export default LoginPage
